import { configureStore } from "@reduxjs/toolkit";
import i18nReducer from "../i18n/i18nSlice";

export default configureStore({
  reducer: {
    i18n: i18nReducer,
  },
});
